import React from 'react';

import {Card, CardContent, CardHeader, Stack, TextField} from '@mui/material';
import {useQuery} from 'react-query';

import API, {Types} from '@wheeebo/polaris-api';
import {GroupPanel} from '@wheeebo/polaris-ui';

interface Props {
  groupId: Types.UUID;
}

const GroupProfileCard = ({groupId}: Props): JSX.Element => {
  const {data} = useQuery(API.Groups.getKey(groupId), () => API.Groups.get(groupId));
  return (
    <Card variant="outlined">
      <CardHeader title="Group Profile" />
      <CardContent>
        <Stack gap={1}>
          <GroupPanel groupId={groupId} />
          <TextField disabled fullWidth variant="standard" label="Group ID" value={groupId} />
          <TextField
            disabled
            fullWidth
            variant="standard"
            label="Description"
            multiline
            value={data?.description || ''}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default React.memo(GroupProfileCard);
